/**
 * MaintenanceCtrl controller
 * Show maintenance message
 */

import {PROVIDERS_CONST} from 'app/core/constants'

// Different messages for different error codes
let messages = {}

// Bad Gateway
messages['502'] = {
  h1: 'Sorry',
  h2: 'Looks like something went wrong on our side,<br>We\'re working hard to fix an issue and improve our services.',
  h3: 'Please wait a while and we’ll be back online shortly.'
}

// Service Unavailable
messages['503'] = {
  h1: 'System Upgrade',
  h2: 'We are performing an upgrade in our system to improve our services.',
  h3: 'Please wait a while and we’ll be back online shortly.'
}

// Gateway Time-out
messages['504'] = messages['502']

/**
 * MaintenanceCtrl controller
 *
 * @class MaintenanceCtrl
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc controller
 * @name mwApp/common.controller:MaintenanceCtrl
 */
/* @ngInject */
export default function MaintenanceCtrl ($sce, $rootScope, $interval, $timeout, $http) {
  var vm = this

  /**
   * Messages for errors
   *
   * @memberof mwApp/common.controller:MaintenanceCtrl
   */
  vm.message = {}

  vm.providersConst = PROVIDERS_CONST

  // trust all messages as HTML
  for (let e in messages) {
    vm.message[e] = {}
    for (let h in messages[e]) {
      vm.message[e][h] = $sce.trustAsHtml(messages[e][h])
    }
  }

  //
  // Spinner hourglass
  //

  const spinElements = [1, 2, 3, 4]
  vm.spinner = spinElements[0]
  vm.PROVIDER = window.ENV.APP_PROVIDER

  $interval(() => {
    let pos = spinElements.indexOf(vm.spinner)
    vm.spinner = spinElements[pos + 1 === spinElements.length ? 0 : pos + 1]
  }, 1000)

  //
  // Check for server
  //

  const check = () =>
    $http.get('api/info/timezone')
      .then(vm.location.reload) // reload state
      .catch(checkIn10Seconds) // in case of error -> run check again in 10 seconds

  const checkIn10Seconds = () =>
    $timeout(check, 10000)

  checkIn10Seconds() // init check cycle
}
